import cx from 'classnames';
import CallContactInfo from 'Components/CallContactInfo';
import { observer } from 'mobx-react';
import { ContactModelV2 } from 'Models/ContactModelV2';
import * as React from 'react';
import {
  formatNumberNoPlusIfUS,
  formatNumberWithNationalCode,
  isPhoneNumber,
  isPhoneNumberMatch,
} from 'Utils/phoneUtil';
import {
  Button,
  Grid,
  Image,
  Loader,
} from '../../../../node_modules/semantic-ui-react';
import { UserAvatar } from '../shared/UserAvatar';
import { CallIncomingListItemProps } from './interfaces';
const endCallIcon = require('../../assets/images/icon-phonecalls.svg');

export class CallIncomingListItem extends React.Component<
  CallIncomingListItemProps,
  {}
> {
  state = {
    callerIdName: this.props.phoneCall.callerIdName,
  };

  rejectCall = () => {
    const { phoneCall } = this.props;
    phoneCall.reject();
  };

  async componentDidMount() {
    await this.setCallerIdName();
  }

  async setCallerIdName() {
    if (isPhoneNumber(this.props.phoneCall.callerIdName)) {
      const phoneNumNoPlus = formatNumberNoPlusIfUS(
        this.props.phoneCall.phoneNumber
      );
      const personModel = await this.props.getPersonFromDirectory(
        phoneNumNoPlus
      );
      if (personModel) {
        this.setState({
          callerIdName: `${personModel.firstName} ${personModel.lastName}`,
        });
      }
    }
  }

  render() {
    const { phoneCall, showMinified, phone: phoneStore } = this.props;

    const avatarEl =
      phoneCall.person !== null ? (
        phoneCall.person.case({
          pending: () => <Loader indeterminate active />,
          rejected: () => <UserAvatar />,
          fulfilled: (response) => {
            const person = response;
            const image = person.avatarUrl;

            if (image?.startsWith('http')) {
              return (
                <img
                  src={image}
                  className={`${
                    phoneStore.ActivePhoneCall?.isCallConnecting
                      ? 'transit-call-image-border'
                      : ''
                  }`}
                />
              );
            } else if (phoneStore.ActivePhoneCall?.callerIdName) {
              return (
                <UserAvatar name={phoneStore.ActivePhoneCall.callerIdName} />
              );
            } else {
              return <UserAvatar name={person.name} />;
            }
          },
        })
      ) : phoneCall.contact ? (
        <UserAvatar
          name={phoneCall.contact.name}
          image={phoneCall.contact.avatarUrl}
        />
      ) : (
        <UserAvatar />
      );

    return (
      <div
        key={phoneCall.pickUpTime + Math.random() * 100}
        className={cx('call-incoming-list-item', 'call-item', {
          minified: showMinified,
          connecting: phoneCall.isCallConnecting,
        })}
      >
        {!showMinified && (
          <div className="contact-image-wrapper">{avatarEl}</div>
        )}
        <div className="contact-info">
          {phoneCall.person &&
            phoneCall.person.case({
              fulfilled: (response) => {
                const person = response;

                return (
                  <CallContactInfo
                    name={`${response?.firstName} ${response?.lastName}`}
                    phoneNumber={
                      person?.lines ? person?.formatNumber() : undefined
                    }
                  />
                );
              },
            })}
          {phoneCall.contact &&
            (() => {
              const phoneNumber = ContactModelV2.formatNumber(
                phoneCall.phoneNumber
              );

              return (
                <CallContactInfo
                  name={phoneCall.contact.name}
                  others={phoneCall.otherContacts}
                  phoneNumber={phoneNumber}
                />
              );
            })()}
          {!phoneCall.contact &&
            !phoneCall.person &&
            phoneCall.callerIdName && (
              <CallContactInfo
                name={
                  isPhoneNumber(phoneCall.callerIdName)
                    ? this.state.callerIdName
                    : phoneCall.callerIdName
                }
                phoneNumber={
                  isPhoneNumberMatch(
                    phoneCall.callerIdName,
                    phoneCall.phoneNumber
                  )
                    ? undefined
                    : formatNumberWithNationalCode(phoneCall.phoneNumber)
                }
              />
            )}
          <div className="transit-call-status">
            <span>
              {phoneCall.isCallConnecting ? 'is calling you' : 'connecting...'}
            </span>
          </div>
        </div>
        <Grid.Column className="call-buttons width-76" textAlign="center">
          <div className="btn-wrapper">
            <Button onClick={this.rejectCall} circular className="end-call">
              <Button.Content visible>
                <Image src={endCallIcon} />
              </Button.Content>
            </Button>
            <span className="btn-text">Cancel</span>
          </div>
          <div className="btn-wrapper">
            <Button
              onClick={phoneCall.pickup}
              circular
              className="answer-call-btn"
            >
              <Button.Content visible>
                <Image
                  src={endCallIcon}
                  style={{ transform: 'rotateZ(-140deg)' }}
                />
              </Button.Content>
            </Button>
            <span className="btn-text">Answer</span>
          </div>
        </Grid.Column>
      </div>
    );
  }
}

export default observer(CallIncomingListItem);
